<template>
  <div class="fill-height">
    <admin-wrapper
      :straight-title="additionalModuleName"
      class="text-left"
      :inputs="inputs"
      :is-fetched="isFetched"
      :hasButtons="false"
    >
      <template #subtitle.input>
        <v-row no-gutters>
          <v-col cols="11" class="text-left mt-n10 pr-10">
            <italic-subheader translation-path="admin.mobileAppOfflineSubtitle"></italic-subheader>
          </v-col>
        </v-row>
      </template>
      <template #actualVersion.input>
        <v-row class="py-3">
          <v-col>
            {{ mobileAppVersion ? mobileAppVersion : $i18n.t('admin.mobileAppMissing') }}
          </v-col>
        </v-row>
      </template>
      <template #layersAttributes.input>
        <mobile-app-layers-row
          row-name="sqlite"
          @openDialog="openSyncDialog"
          :is-fetching="isSQLiteFetching"
          :date="dateSqQLite"
        ></mobile-app-layers-row>
      </template>
      <template #layersGeometry.input>
        <mobile-app-layers-row
          row-name="tiles"
          @openDialog="openSyncDialog"
          :is-fetching="isTilesFetching"
          :date="dateMBTiles"
        ></mobile-app-layers-row>
      </template>
    </admin-wrapper>
    <main-dialog
      v-if="isDialogLoaded"
      :is-visible.sync="isDialogVisible"
      :title="dialogTitle"
      :body="dialogBody"
      @agree="handleAgreeSync"
      agree-text="dialog.agreeGenerate"
    ></main-dialog>
  </div>
</template>

<script>
import { call, get } from 'vuex-pathify';

import ItalicSubheader from '@/components/ItalicSubheader';
import AdminWrapper from '@/components/AdminWrapper';
import MobileAppLayersRow from '@/components/MobileAppLayersRow';

export default {
  name: 'MobileAppOffline',
  components: {
    MobileAppLayersRow,
    ItalicSubheader,
    AdminWrapper,
    MainDialog: () => import('@/components/MainDialog'),
  },
  data: () => ({
    isConfirmButtonLoading: false,
    isDialogLoaded: false,
    isDialogVisible: false,
    activeDialog: '',
    isFetched: false,
    isSQLiteFetching: false,
    isTilesFetching: false,
    inputs: [
      {
        name: 'subtitle',
        hasSuffix: false,
      },
      {
        name: 'actualVersion',
        translationPath: 'admin.actualVersion',
      },
      {
        name: 'layersAttributes',
        translationPath: 'admin.layersAttributes',
      },
      {
        name: 'layersGeometry',
        translationPath: 'admin.layersGeometry',
      },
    ],
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules@AQUAGIS_OFFLINE_MOBILE.verbose_name'),
    mobileAppVersion: get('admin/mobileAppMetadata@aquagis_offline.version'),
    dateSqQLite: get('admin/settingsValues@sync_sqlite_generated_datetime'),
    dateMBTiles: get('admin/settingsValues@sync_tiles_generated_datetime'),
    dialogTitle() {
      if (this.activeDialog === 'tiles') {
        return this.$i18n.t('dialog.title.mbtilesTitle');
      } else {
        return this.$i18n.t('dialog.title.sqliteTitle');
      }
    },
    dialogBody() {
      if (this.activeDialog === 'tiles') {
        return this.$i18n.t('dialog.body.mbtilesBody');
      } else {
        return this.$i18n.t('dialog.body.sqliteBody');
      }
    },
  },
  methods: {
    syncMbtiles: call('admin/syncMbtiles'),
    syncSqlite: call('admin/syncSqlite'),
    getMobileMetadata: call('admin/getMobileMetadata'),
    async handleGetMobileMetadata() {
      await this.getMobileMetadata('aquagis_offline');
      this.isFetched = true;
    },
    async handleSyncMBTiles() {
      try {
        this.isTilesFetching = true;
        await this.syncMbtiles({ reload_geojson: true });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.mbtilesSynced'),
        });
      } catch (error) {
        console.log(error);
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.syncTilesFailed'),
        });
      } finally {
        this.isTilesFetching = false;
      }
    },
    async handleSyncSQLite() {
      try {
        this.isSQLiteFetching = true;
        await this.syncSqlite({ srid: 2180 });
        this.$store.set('snackbar/PUSH_SUCCESSFULLY_MESSAGE!', {
          message: this.$i18n.t('success.sqliteSynced'),
        });
      } catch (error) {
        console.log(error);
        this.$store.set('snackbar/PUSH_ERROR!', {
          message: this.$i18n.t('errors.syncSqliteFailed'),
        });
      } finally {
        this.isSQLiteFetching = false;
      }
    },
    openSyncDialog(name) {
      this.activeDialog = name;
      this.isDialogLoaded = true;
      this.isDialogVisible = true;
    },
    handleAgreeSync() {
      this.isDialogVisible = false;
      this.isDialogLoaded = false;
      if (this.activeDialog === 'tiles') {
        this.handleSyncMBTiles();
      } else {
        this.handleSyncSQLite();
      }
    },
  },
  created() {
    this.handleGetMobileMetadata();
  },
};
</script>

<style lang="scss" scoped></style>
